var _rect, _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgPoliySearchIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39.5212,
    height: 38.75,
    rx: 3,
    fill: "#9694E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5309 23.3017C30.4278 22.0421 30.9179 20.5432 30.9179 18.9661C30.9179 17.3715 30.4162 15.8569 29.5 14.5894V7.5H7V25H17V28.75H12V31.25H24.5V28.75H19.5V25.3397C20.6992 26.076 22.0548 26.4624 23.4179 26.4624C24.9433 26.4624 26.4581 25.9814 27.7536 25.0597L30.761 28.042L32.5212 26.2671L29.5309 23.3017ZM16.7992 22.5H9.5V10H27V12.376C25.9132 11.7832 24.6904 11.4661 23.4185 11.4661C21.4147 11.4661 19.5317 12.2461 18.1151 13.6633C16.6985 15.0793 15.9185 16.9629 15.9185 18.9661C15.9185 20.2191 16.2238 21.4255 16.7992 22.5ZM26.9536 22.5024C25.0054 24.4519 21.8334 24.4519 19.8827 22.5024C18.9385 21.5576 18.4184 20.3015 18.4184 18.9661C18.4184 17.6306 18.9385 16.3757 19.8827 15.4309C20.8275 14.4861 22.083 13.9661 23.4185 13.9661C24.7533 13.9661 26.0088 14.4861 26.9536 15.4309C27.8978 16.3757 28.4178 17.6306 28.4178 18.9661C28.4178 20.3015 27.8978 21.5576 26.9536 22.5024Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPoliySearchIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Poliy_Search_Icon.b271688b.svg";
export { ForwardRef as ReactComponent };